import { createContext, useContext } from 'react';
import type { GeolocateControlInstance } from 'react-map-gl/mapbox';

export const GeolocateStatus = {
  DISABLED: 'disabled',
  LOCATING: 'locating',
  TRACKING: 'tracking',
  VISIBLE: 'visible',
} as const;

export type GeolocateStatus =
  (typeof GeolocateStatus)[keyof typeof GeolocateStatus];

export interface GeolocateContextType {
  setGeolocateControlRef: (ref: GeolocateControlInstance) => void;
  status: GeolocateStatus;
  setStatus: (status: GeolocateStatus) => void;
}

export const GeolocateContext = createContext<GeolocateContextType | null>(
  null
);

export const useGeolocateControl = () => {
  const context = useContext(GeolocateContext);
  if (!context) {
    throw new Error(
      'useGeolocateControl must be used within GeolocateProvider'
    );
  }
  return context;
};
